import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const VideoIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0832 6.41663L14.6665 11L21.0832 15.5833V6.41663Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8332 4.58337H2.74984C1.73732 4.58337 0.916504 5.40419 0.916504 6.41671V15.5834C0.916504 16.5959 1.73732 17.4167 2.74984 17.4167H12.8332C13.8457 17.4167 14.6665 16.5959 14.6665 15.5834V6.41671C14.6665 5.40419 13.8457 4.58337 12.8332 4.58337Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
